import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { OverlayEventDetail } from '@ionic/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { GlobalService } from '../global.service';
import { AjaxService } from '../ajax.service';
import { ScanCameraPage } from '../scan-camera/scan-camera.page';

interface ApiResponse {
    login: boolean;
    txt: any;
    msg?: string;
    des?: string;
    eenh?: string;
    loc?: string;
    vrd?: number;
    vvrd?: number;
    mvrd?: number;
    verbruik?: number;
    foto?: boolean;
}

@Component({
    selector: 'app-home',
    templateUrl: 'home.page.html',
    styleUrls: ['home.page.scss'],
    standalone: false
})
export class HomePage implements OnInit {
    Math = Math;
    artlist: any[] = [];
    inpArtnr = '';
    inpArtSubject: Subject<string> = new Subject();
    blockArtList = false;
    artShow: any = {
        nr: '0123456',
        descr: 'Voorbeeld artikel',
        eenh: 'St.',
        voorraad: 11,
        vrijevoorraad: 10,
        verbruik: 100,
        locatie: '1ZA203',
        minvr: 3,
        metFoto: false
    };
    imgs   = [];
    viewerOpen = false;
    scanCamera = false;
    magVoorraadWijz = false;
    bestelForm = false;
    BestelAantal = 1;

    constructor(
        private router: Router,
        private snackBar: MatSnackBar,
        public global: GlobalService,
        public alertController: AlertController,
        public modalController: ModalController,
        public http: HttpClient,
        private ajax: AjaxService,
    ) { }

    ngOnInit() {
        if (!this.global.isLoggedIn) {
            this.router.navigateByUrl('login');
        }

        this.inpArtSubject.pipe(
            debounceTime(500),
            distinctUntilChanged()
        ).subscribe(
            value => {
                this.onChangeArt(value);
            }
        );

    }

    ionViewWillEnter() {
        this.magVoorraadWijz = (this.global.getvar('usrVoorraad', '0') === '1');

        const artnr: string = localStorage.getItem('lastArtNr');
        if (artnr) {
            this.inpArtnr = artnr;
            this.showArtKaart(artnr);
        }
        const projnr: string = localStorage.getItem('lastProjNr');
        if (projnr) {
            this.global.currProjNr = projnr;
        }
        const bedr: string = localStorage.getItem('lastBedr');
        if (bedr) {
            this.global.currBedr = bedr;
        }
    }

    async doScan() {
        if (!await this.global.startCamera()) {
            return;
        }
        this.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss()
        .then((dataPar: OverlayEventDetail) => {
            this.scanCamera = false;
            if (dataPar.data.code) {
                this.inpArtnr = dataPar.data.code;
                this.showArtKaart(this.inpArtnr);
            }
        });
        return await myDlg.present();
    }

    async doScanEAN() {
        if (!await this.global.startCamera()) {
            return;
        }
        this.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss()
        .then((dataPar: OverlayEventDetail) => {
            this.scanCamera = false;
            if (dataPar.data.code) {
                this.ajax.get('updateRecord', {
                    table: 'artikelen',
                    field: 'ArtNr',
                    value: this.artShow.nr,
                    fields: { EAN: dataPar.data.code },
                }).then((data: any) => {
                    this.artShow.ean = dataPar.data.code;
                });
            }
        });
        return await myDlg.present();
    }

    artChanged(event) {
        this.inpArtSubject.next(event);
    }

    onChangeArt(nwArtNr) {
        if (!this.blockArtList) {
            console.log('onChangeArt: ' + nwArtNr);
            this.ajax.get('artList', { req: nwArtNr })
                .then((data: any) => {
                    if (!data.login) {
                        this.dataError(data);
                    } else {
                        console.log('artList = ', data);
                        this.artlist = data.txt;
                        if ((this.artlist.length === 1 && this.artlist[0].nr.toLowerCase().trim() === nwArtNr.toLowerCase().trim())
                            || data.msg === 'FOUND 1'
                        ) {
                            this.click_art(this.artlist[0].nr.trim());
                        } else {
                            data.txt.forEach(element => {
                                if (element.nr.toLowerCase().trim() === nwArtNr.toLowerCase().trim()) {
                                    this.showArtKaart(nwArtNr.trim());
                                }
                            });
                        }
                    }
                }
                );
        }
    }

    click_art(nwArtNr) {
        this.inpArtnr = nwArtNr;
        this.artlist = [];
        this.showArtKaart(nwArtNr);
    }

    showArtKaart(artnr) {
        console.log('showArtKaart: ' + artnr);
        this.ajax.get('artData', { req: artnr })
            .then((data: any) => {
                if (!data.login) {
                    this.dataError(data);
                    this.blockArtList = false;
                } else {
                    console.log('got1 = ', data);
                    this.artShow.nr = data.artnr;
                    this.inpArtnr = data.artnr;
                    this.artShow.descr = data.des;
                    this.artShow.note = data.descr;
                    this.artShow.eenh = data.eenh;
                    this.artShow.locatie = data.loc;
                    this.artShow.ean = data.ean;
                    this.artShow.voorraad = data.vrd;
                    this.artShow.vrijevoorraad = data.vvrd;
                    this.artShow.minvr = data.mvrd;
                    this.artShow.verbruik = data.verbruik;
                    this.artShow.metFoto = data.foto;
                    this.artShow.kenmerken = data.kenmerken;
                    this.artShow.besteld = data.besteld;
                    this.artShow.besteldConcept = data.besteldConcept;
                    this.artShow.inkMin = data.inkMin;
                    this.BestelAantal = data.inkMin;
                    this.artShow.inkStp = data.inkStp;

                    this.artShow.imgUrl = this.global.baseurl
                        + 'api/img.php?t=artikelen&f=Foto&i=ArtNr&v=' + data.artnr
                        + '&compname=' + this.global.compname
                        + '&username=' + this.global.username
                        + '&password=' + this.global.password
                        + '&session=' + this.global.session
                        + '&app=BAR3'
                        + '&pcnr=' + this.global.uuid;
                    this.imgs[0] = {
                        filename: data.artnr,
                        path: '',
                        txt: data.artnr,
                        url: this.artShow.imgUrl
                    };
                    this.global.currArtNr = data.artnr;
                    localStorage.setItem('lastArtNr', data.artnr);
                    this.blockArtList = false;
                }
            }
            );
    }

    async telling() {
        console.log('telling');
        const alert = await this.alertController.create({
            header: 'Voorraad correctie',
            inputs: [
                {
                    name: 'nwStand',
                    type: 'number',
                    placeholder: 'Nieuwe voorraad-stand',
                    value: this.artShow.voorraad
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('telling cancelled');
                    }
                }, {
                    text: 'Ok',
                    handler: (alertData) => {
                        this.ajax.get('artTelling', {
                            req: this.artShow.nr,
                            qty: alertData.nwStand
                        })
                            .then((data: any) => {
                                if (!data.login) {
                                    this.dataError(data);
                                } else {
                                    console.log('got2 = ', data);
                                    this.showArtKaart(this.artShow.nr);
                                }
                            }
                            );
                    }
                }
            ]
        });
        await alert.present();
    }

    async chLoc() {
        console.log('chLoc');
        const alert = await this.alertController.create({
            header: 'Wijzig locatie',
            inputs: [
                {
                    name: 'nwLoc',
                    type: 'text',
                    placeholder: 'Nieuwe locatie',
                    value: this.artShow.locatie
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('chLoc cancelled');
                    }
                }, {
                    text: 'Ok',
                    handler: (alertData) => {
                        this.ajax.get('artTelling', {
                            req: this.artShow.nr,
                            loc: alertData.nwLoc
                        })
                            .then((data: any) => {
                                if (!data.login) {
                                    this.dataError(data);
                                } else {
                                    console.log('got3 = ', data);
                                    this.showArtKaart(this.artShow.nr);
                                }
                            }
                            );
                    }
                }
            ]
        });
        await alert.present();
    }

    async dataError(data) {
        this.snackBar.open('Nieuwe login noodzakelijk.', 'OK', {
            duration: 1000
        });
        this.router.navigateByUrl('login');
    }

    plaatsBestelling() {
        this.ajax.get('artBestelling', {
            req: this.artShow.nr,
            qty: this.BestelAantal
        })
        .then((data: any) => {
            if (!data.login) {
                this.dataError(data);
            } else {
                console.log('besteld = ', data);
                this.bestelForm = false;
                if (data.ponr) {
                    this.snackBar.open('Zie inkoop '+data.ponr+'->'+data.lev, 'OK', {
                        duration: 3000
                    });
                } else {
                    this.snackBar.open('Bestelling NIET geplaatst!', 'OK', {
                        duration: 3000
                    });
                }
                this.showArtKaart(this.artShow.nr);
            }
        });
    }
}
